class MenuBillings {
 	 [x: string]: any;
 	 static $inject = ['BASE_URL'];
    constructor(BASE_URL) {
        this.backend = BASE_URL;
    }
    replaceFind(){
        this.find = this.searchInput.replace(/\+/g, '\\+');
        this.onSearchType({searchText: this.find});
    }

}

export default {
    controller: MenuBillings,
    template : require('./menu.billings.pricing.html'),
    bindings: {
        onSearchType: '&'
    }
};
